// ============================================================================
// formTypes.ts — ДЕТЕРМИНИРОВАННЫЙ определитель типа поля/колонки (SRP/SSoT).
// Вынесено из CustomLayoutRenderer (используется в рендере ТЧ и полей) —
// единый источник правил «мета-тип → UI-тип» + сборка types[] из строки.
// ============================================================================

export type UiFieldType = 'string' | 'number' | 'date' | 'boolean' | 'reference' | 'select' | 'enum' | 'file' | 'timestamp' | 'uuid';

/** Мета-тип (русский/латиница/число/дата/...) → UI-тип. fkTable = ссылка. */
export function detectFieldType(metaType: string, fkTable?: string): UiFieldType {
  const t = (metaType || '').toLowerCase();
  // ПЕРЕЧИСЛЕНИЕ — ДО проверки fkTable: у enum в fkTable лежит КОД перечисления
  // (а не таблица-источник). Иначе поле становилось «ссылкой» и на форме не было
  // селекта значений (нельзя выбрать «Вид» и т.п.).
  if (t === 'enum' || t === 'enumeration' || t.includes('перечисление')) return 'enum';
  if (fkTable) return 'reference';
  if (t === 'anyref' || t.includes('любая ссылка')) return 'reference';
  if (t.includes('число') || t.includes('number') || t.includes('numeric')) return 'number';
  if (t.includes('целое') || t === 'integer') return 'number';
  if (t.includes('дата') || t.includes('date')) {
    if (t.includes('время') || t === 'timestamp') return 'timestamp';
    return 'date';
  }
  if (t === 'timestamp') return 'timestamp';
  if (t.includes('булево') || t.includes('boolean')) return 'boolean';
  if (t.includes('ссылка') || t.includes('reference') || t.includes('справочник') || t.includes('документ')) return 'reference';
  if (t.includes('перечисление') || t.includes('enumeration') || t === 'enum') return 'enum';
  if (t === 'file' || t.includes('файл')) return 'file';
  if (t === 'uuid') return 'uuid';
  return 'string';
}

export interface ResolvedTypeRef {
  typeName: string;
  fullName: string;
  objectType: string;
}

/** Собирает types[] из строки type (для колонок, где types[] отсутствует в макете). */
export function buildTypesFromTypeString(typeStr: string): ResolvedTypeRef[] {
  if (!typeStr) return [];
  const t = typeStr.toLowerCase();
  if (t === 'reference' || t === 'select' || t === 'string' || t === 'number' || t === 'date' || t === 'boolean') return [];
  const isAny = t.includes('любая ссылка') || t === 'anyref';
  if (isAny) return [];
  const parts = typeStr.split('.');
  if (parts.length === 2) {
    const obj = parts[0].toLowerCase();
    const code = parts[1];
    const objectType = obj.includes('справочник') || obj === 'catalog' ? 'catalog'
      : obj.includes('документ') || obj === 'document' ? 'document'
      : obj.includes('задача') || obj === 'task' ? 'task'
      : obj.includes('заявка') || obj === 'order' ? 'order'
      : obj.includes('регистр') || obj === 'register' ? 'register'
      : obj.includes('перечисление') || obj === 'enum' ? 'enum'
      : obj;
    return [{ typeName: code, fullName: typeStr, objectType }];
  }
  return [];
}
